export const calculateSrc = ({ desiredWidth, desiredHeight, url, quality = 80, focalPoint = "center", crop, fit = "width", }) => {
    const paramsObj = {
        auto: "format",
        fit: "fill",
    };
    const onlyWidth = !!desiredWidth && !desiredHeight;
    const onlyHeight = !!desiredHeight && !desiredWidth;
    const setWidthParam = () => {
        paramsObj.w = `${desiredWidth}`;
    };
    const setHeightParam = () => {
        paramsObj.h = `${desiredHeight}`;
    };
    const fitToHeightOrWidth = () => {
        if (fit === "height") {
            setHeightParam();
        }
        else if (desiredWidth) {
            setWidthParam();
        }
    };
    const cropImage = () => {
        setHeightParam();
        setWidthParam();
        paramsObj.fit = "crop";
        paramsObj.crop = focalPoint;
    };
    if (quality) {
        paramsObj.q = `${quality}`;
    }
    if (onlyWidth) {
        setWidthParam();
    }
    if (onlyHeight) {
        setHeightParam();
    }
    if (desiredWidth && desiredHeight) {
        if (crop) {
            cropImage();
        }
        else {
            fitToHeightOrWidth();
        }
    }
    const newSrc = new URL(`${url}?${new URLSearchParams([...Object.entries(paramsObj)])}`);
    return newSrc.toString();
};
//# sourceMappingURL=calculateSrc.js.map